import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  container: {
    backgroundColor: colors.backgroundL0,
  },
  header: {
    justifyContent: 'space-between',
  },
  content: {
    paddingHorizontal: theme.spacing[5],
    paddingBottom: theme.spacing[7],
    alignItems: 'center',
  },
  qrCodeContainer: {
    width: 280,
    height: 280,
    backgroundColor: colors.backgroundPrimary,
    borderRadius: theme.borderRadius.m,
    padding: theme.spacing[4],
    marginBottom: theme.spacing[6],
    shadowColor: colors.borderPrimary,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
  },
  timerContainer: {
    marginBottom: theme.spacing[5],
  },
  timerValue: {
    color: colors.textPrimary,
  },
  instructions: {
    textAlign: 'center',
    color: colors.textPrimary,
    marginBottom: theme.spacing[4],
  },
  troubleshooting: {
    textAlign: 'center',
    color: colors.textSecondary,
  },
  loadingContainer: {
    paddingVertical: theme.spacing[10],
    alignItems: 'center',
  },
  errorContainer: {
    paddingVertical: theme.spacing[10],
    alignItems: 'center',
  },
  errorText: {
    color: colors.textNegative,
    textAlign: 'center',
  },
}));
